export const checkKana = (str: string): string => {
  if (str === '' || str === undefined) return ''; // 未入力の場合にはエラー判定しない

  const result = str.match(/^[ァ-ヶー　\(ぁ-ん)\(ｦ-ﾟ)\(a-zA-Z)]*$/)
  return result ? '' : 'カタカナ・ひらがな・英字のみが使用できます'
}
